__turbopack_context__.v({
  "counterOfferModalSuccessButton": "styles-module__PQho7q__counterOfferModalSuccessButton",
  "counterOfferModalSuccessContainer": "styles-module__PQho7q__counterOfferModalSuccessContainer",
  "counterOfferModalSuccessText": "styles-module__PQho7q__counterOfferModalSuccessText",
});
